<template>
  <modal-display
    :value="isVisible"
    close-button
    close-button-class="m-3"
    @input="handleClose"
  >
    <div class="bg-white rounded-lg container relative pb-24 md:pb-18">
      <div
        class="md:hidden flex justify-start py-4 px-4 bg-white border-b border-gray-light"
      >
        <btn
          type="submit"
          :disabled="isContentEmpty || isSubmitting"
          class="w-26"
          @click="handleSubmit"
        >
          <div v-if="isSubmitting" class="flex items-center justify-center">
            <icon-spinner class="stroke-white" />
          </div>
          <span v-else>
            {{ editingComment ? $t('common.update') : $t('common.save') }}
          </span>
        </btn>
      </div>

      <form
        class="pt-6 md:pt-10 px-4 md:px-8 flex flex-col h-full"
        @submit.prevent="handleSubmit"
      >
        <div
          class="flex flex-1 gap-6 min-h-0 flex-col md:flex-row overflow-y-auto"
        >
          <survey-question-details
            v-model="selectedStatus"
            :question-index="questionIndex"
            :question-type="questionType"
            :question-name="questionName"
            :answer="answer"
            :question-comment="questionComment"
            :question-file="questionFile"
            :survey-internal-number="surveyInternalNumber"
            :user-full-name="userFullName"
            :place-name="placeName"
            :status-options="statusOptions"
            :survey-user-id="surveyUserId"
            :question-status="questionStatus"
            :question="question"
            :survey-user="surveyUser"
            :is-editor="isEditor"
            @answer-change="handleChangeAnswer"
            @attachment-change="handleAttachmentChange"
          />

          <survey-question-comments
            ref="commentsComponent"
            v-model="form.content"
            :comments="comments"
            :is-loading-comments="isLoadingComments"
            :is-deleting-comment="isDeletingComment"
            :editing-comment="editingComment"
            :comments-url="commentsUrl"
            :comments-query="commentsQuery"
            :should-fetch-comments="shouldFetchComments"
            :force-update="forceUpdateComments"
            @refresh-comments="fetchComments"
            @delete-comment="handleDeleteComment"
            @edit-comment="handleEditComment"
            @cancel-edit="cancelEdit"
            @comments-loaded="handleCommentsLoaded"
          />
        </div>
      </form>

      <div
        class="hidden md:flex absolute bottom-0 left-0 right-0 justify-end py-4 px-8 bg-white"
      >
        <btn
          type="submit"
          :disabled="isSubmitting"
          class="w-26"
          @click="handleSubmit"
        >
          <div v-if="isSubmitting" class="flex items-center justify-center">
            <icon-spinner class="stroke-white" />
          </div>
          <span v-else>
            {{ editingComment ? $t('common.update') : $t('common.save') }}
          </span>
        </btn>
      </div>
    </div>
  </modal-display>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import ModalDisplay from '@/components/Modal/ModalDisplay.vue';
import SurveyQuestionDetails from '@/views/Brand/Surveys/Users/_components/SurveyQuestionDetails.vue';
import SurveyQuestionComments from '@/views/Brand/Surveys/Users/_components/SurveyQuestionComments.vue';
import Btn from '@/components/Button/Button.vue';
import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
import { useSurveyQuestionModal } from '@/views/Brand/Surveys/Users/_composables/use-survey-question-modal';

export default defineComponent({
  name: 'SurveyQuestionModal',
  components: {
    ModalDisplay,
    Btn,
    IconSpinner,
    SurveyQuestionDetails,
    SurveyQuestionComments,
  },
  props: {
    isVisible: { type: Boolean, default: false },
    question: { type: Object, default: null },
    answer: { type: String, default: '' },
    questionFile: { type: String, default: '' },
    questionComment: { type: String, default: '' },
    questionIndex: { type: Number, default: 0 },
    surveyInternalNumber: { type: Number, default: null },
    userFullName: { type: String, default: null },
    placeName: { type: String, default: null },
    placeId: { type: String, default: null },
    surveyUserId: { type: String, default: null },
    questionStatus: { type: String, default: null },
    surveyUser: { type: Object },
    isEditor: { type: Boolean, default: false },
    answers: { type: Array, default: () => [] },
  },
  setup(props, ctx) {
    const modalLogic = useSurveyQuestionModal(props, ctx);

    modalLogic.setupWatchers();
    return {
      ...modalLogic,
    };
  },
});
</script>

<style scoped>
.container {
  width: 880px;
  height: 790px;
  max-height: 790px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .container {
    width: 98vw;
    height: 98vh;
    max-height: none;
    overflow: hidden;
  }
}
</style>
